import { useContext, type FC, type PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

import UserContext from 'app/common/UserContext';
import { useThemedColor } from 'app/hooks/useThemedColors';
import FormField from 'app/components/FormField';
import Icon from 'app/components/Icon';
import moonIcon from 'app/icons/moon.svg';
import sunIcon from 'app/icons/sun.svg';

import style from './style.scss';

interface Props extends PropsWithChildren {
  title?: string;
}

const FormFieldWrapper: FC<any> = props => (
  <FormField {...props} labelClassName={style.inputLabel} />
);

const LoginLayout: FC<Props> = ({ children, title }) => {
  const { t } = useTranslation();

  const {
    setLoginTheme,
    preferences: { theme }
  } = useContext(UserContext);

  const backgroundGradient = useThemedColor({
    dark: 'linear-gradient(160deg, #1B1B22 13%, #24242D 172.71%)',
    light: 'linear-gradient(160deg, #F4F7FA 13%, #CFDEF3 172.71%), #F4F7FA'
  });

  const buttonBacground = useThemedColor({
    dark: 'rgb(207, 213, 221)',
    light: 'rgb(54, 54, 68)'
  });
  const buttonColor = useThemedColor({
    dark: 'rgba(95, 110, 133, 1)',
    light: 'rgba(255, 255, 255, 0.6)'
  });

  return (
    <main className={style.main} style={{ background: backgroundGradient }}>
      <div className={style.container}>
        <header className={style.header}>
          <h1>{t('pandascore')}</h1>
          <h2>{t('login-header-subtitle')}</h2>
        </header>
        <div className={style.loginBlock}>
          {title && <h3 className={style.title}>{title}</h3>}
          {children}
        </div>
      </div>
      <button
        type="button"
        onClick={() => setLoginTheme(theme === 'light' ? 'dark' : 'light')}
        aria-label="Switch theme"
        className={style.themeButton}
        style={{ background: buttonBacground, color: buttonColor }}
        tabIndex={-1}
      >
        <Icon href={theme === 'light' ? moonIcon : sunIcon} />
      </button>
    </main>
  );
};

LoginLayout.displayName = 'LoginLayout';

export default LoginLayout;
export { FormFieldWrapper };
